import { Login } from '../components'
const LoginPage = () => {
  return (
    <Login/>
  )
}

export default LoginPage